import styled from 'styled-components';

import { colors, spacing } from '../../theme';
import { hexWithOpacity } from '../../utils';

const fadeInDuration = 200;
const fadeOutDuration = 200;

export const Container = styled.div<{ $isExpanded: boolean }>`
  position: absolute;
  right: 50%;
  bottom: ${spacing['20x']};
  display: flex;
  align-items: center;
  padding: 24px 40px 24px 32px;
  background-color: ${colors.white};
  border-radius: 20px;
  box-shadow: 4px 4px 20px ${hexWithOpacity(colors.navy, 0.5)};
  opacity: ${({ $isExpanded }) => !$isExpanded && 0};
  transition: opacity ${fadeOutDuration}ms ease-out;
  transform: translateX(50%);
  animation: fade-in ${fadeInDuration}ms ease-in;
`;
